import { Component, OnInit } from '@angular/core';
import { AccessUserInfo, LabRequest, LabRequestDetail, UserDetail } from 'src/app/models';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoaderService } from 'src/app/services/loader.service';
import { LabRequestService, LabRequisitionService, UserService } from 'src/app/services';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SelectItem } from 'primeng';
import { DatePipe } from '@angular/common';
import { UserAction } from 'src/app/enum/user/userActions';
import { ScreenName, UserActionDescription } from 'src/app/enum/user/userActionDescription';
import{PreferredLabName} from 'src/app/enum/water-lab/preferredLab'

@Component({
  selector: 'bart-additional-test',
  templateUrl: './additional-test.component.html',
  styleUrls: ['./additional-test.component.scss']
})
export class AdditionalTestComponent implements OnInit {
  datePipe = new DatePipe('en-US')
  public userInfo: UserDetail;
  createLabRequestForm: FormGroup;
  labRequestDetails: LabRequestDetail
  labRequestID: number
  labRequestRowData: LabRequest
  enableProviderDDL: boolean = false;
  labTestdata: SelectItem[];
  labProfileData: SelectItem[];
  equipmentID: number
  isSaveButtonDisabled: boolean = true;
  preferredLabName:string;
  radioButtons: any[] = [{ name: 'Individual Test', key: 'I' }, { name: 'Profile', key: 'P' }];
  constructor(private formBuilder: FormBuilder,
    private _loaderService: LoaderService,
    private _waterLabService: LabRequestService,
    public dialogConfig: DynamicDialogConfig,
    private _dynamicDialogRef: DynamicDialogRef,
    private _requisitionService : LabRequisitionService,
    private _userService:UserService
    ) { }

  ngOnInit() {
    this.preferredLabName=PreferredLabName.name;
    this.userInfo = AccessUserInfo.getUserInfo();
    this.labRequestRowData = this.dialogConfig.data.data;
    if (this.labRequestRowData) {
      this.labRequestID = this.labRequestRowData.LabRequestID;
      this.equipmentID = this.dialogConfig.data.data.EquipmentID
    }
    this.createLabRequestForm = this.formBuilder.group({
      labTest: [""],
      labProfile: [""],
      individualTest: [this.radioButtons[0],],
    });
    this.getLabRequestDetails(this.labRequestID,);

  }
  getLabRequestDetails(labRequestID: number) {
    this._loaderService.show()
    let getLabRequestDetailsParam = {
      "GETLABREQUESTDETAIL": {
        "LabRequestID": labRequestID
      }
    }
    this._waterLabService.getLabRequestDetails(JSON.stringify(getLabRequestDetailsParam)).subscribe(data => {
      this.labRequestDetails = data.labRequestDetails[0];
      this.enableProviderDDL = this.labRequestDetails.LabSource == 'Provider' ? true : false;
      this.labRequestDetails.LabTests = this.labRequestDetails.IsProfile == false && this.labRequestDetails.LabTestsJson != null ? this.selectedTestdata(this.labRequestDetails.LabTestsJson) : null,
        this.labRequestDetails.LabProfile = this.labRequestDetails.IsProfile == true && this.labRequestDetails.LabProfileJson != null ? this.selectedProfiledata(this.labRequestDetails.LabProfileJson) : null,
        this.createLabRequestForm.patchValue({
          individualTest: this.labRequestDetails.IsProfile ? this.radioButtons[1] : this.radioButtons[0],
        })
      this.getDropdownData(this.equipmentID);
      // this._loaderService.hide();
    },
      err => {
        this._loaderService.hide()
      });

  }
  selectedTestdata(Jsondata: any) {
    var data = JSON.parse(Jsondata);
    return data.map(data => ({
      label: data.TestDisplayName,
      value: data.LabTestMasterID,
    }));

  }
  selectedProfiledata(Jsondata: any) {
    var data = JSON.parse(Jsondata);
    return data.map(data => ({
      label: data.ProfileDisplayName,
      value: data.LabProfileMasterID,
    }));

  }
  getDropdownData(equipmentId: number) {
    this.createLabRequestForm.get('labTest').setValue(null);
    this.createLabRequestForm.get('labProfile').setValue(null);
    if (equipmentId != null) {
      this._loaderService.show()
      let getLabTestsParam = {
        "GETLABTESTS": {
          EquipmentID: equipmentId,
        },
      }
      let getLabProfileParam = {
        "GETLABPROFILES": {
          EquipmentID: equipmentId,
        },
      }
      if (!this.labRequestDetails.IsProfile) {
        this._waterLabService.getLabTestData(JSON.stringify(getLabTestsParam)).subscribe(res => {
          if (res.length > 0) {
            this.labTestdata = res.map(data => ({
              label: data.LabTestDisplayName,
              value: data.LabTestMasterId,
            }));
            // start excluding existing labTest from list
              let testData: any[] = this.labRequestDetails.LabTests;
              if(testData !=null){
                this.labTestdata = this.labTestdata.filter(val => {
                  return !testData.find((val2) => {
                    return val.value == val2.value;
                  })
                });
              }
             
              // end excluding existing labTest from list
            this._loaderService.hide()
          }
          else {
            this.labTestdata = null;
            this._loaderService.hide()
          }
          ;
        },
          err => {
            this._loaderService.hide()
          });
      }
      else {
        this._waterLabService.getLabProfile(JSON.stringify(getLabProfileParam)).subscribe(res => {
          if (res.length > 0) {
            this.labProfileData = res.map(data => ({
              label: data.ProfileDisplayName,
              value: data.LabProfileMasterId,
            }));
            // start excluding existing profiles from list
              let profileData: any[] = this.labRequestDetails.LabProfile;
              this.labProfileData = this.labProfileData.filter(val => {
                return !profileData.find((val2) => {
                  return val.value == val2.value;
                })
              });
              // end excluding existing profiles from list
            this._loaderService.hide();
          }
          else {
            this.labProfileData = null;
            this._loaderService.hide()
          }
        },
          err => {
            this._loaderService.hide()
          });
      }
    }
    else {
      this.labProfileData = null;
      this.labTestdata = null;
    }
  }
  closePopup() {
    this._dynamicDialogRef.destroy();
    this._dynamicDialogRef.close(false);
     //#region User Action Audit
   this._userService.logUserAction({
    userName: this.userInfo.userName,
    userAction: UserAction.BUTTON_CLICKED,
    screenName: ScreenName.ADDITIONAL_TEST,
    screenPath: location.pathname,
    key: "LabRequestID",
    value: this.labRequestID ,
    eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_ADD_TEST_TO_REQUEST_CANCEL_CLICKED
  });
  //#endregion
  }
  onSubmit() {
    this.checkValidity()
    if (this.createLabRequestForm.valid) {
      this.isSaveButtonDisabled = true;
      this._loaderService.show();
      let isProfile: any = this.createLabRequestForm.get("individualTest").value["name"] == "Profile" ? true : false;
      let LabRequisitionDetails = {
        "CREATEREQUISITIONFORADDITIONALTEST": {
          UserName: this.userInfo.userName,
          LabRequestID: this.labRequestID,
          MappingID: isProfile ? this.createLabRequestForm.get("labProfile").value.map(x => x.value.toString()).toString() : !isProfile ? this.createLabRequestForm.get("labTest").value.map(x => x.value.toString()).toString() : '',
          IsProfile: isProfile,
        }
      }
      this._requisitionService.CreateRequisitionForAdditionalTest(JSON.stringify(LabRequisitionDetails)).subscribe(data => {
        if (data.result) {
          this._loaderService.hide();
          this.isSaveButtonDisabled = false;
          this._dynamicDialogRef.close(true);
        }
        else {
          this._loaderService.hide();
        }
      },
        err => {
          console.log("CreateRequisitionForAdditionalTest" + err.error.error)
          this._loaderService.hide();
        });
    }
          //#region User Action Audit
      this._userService.logUserAction({
        userName: this.userInfo.userName,
        userAction: UserAction.BUTTON_CLICKED,
        screenName: ScreenName.ADDITIONAL_TEST,
        screenPath: location.pathname,
        key: "LabRequestID",
        value: this.labRequestID ,
        eventDescription:UserActionDescription.SHIPPING_MANIFEST_PENDING_ADD_TEST_TO_REQUEST_SAVE_CLICKED
      });
      //#endregion
  }
  public checkValidity(): void {
    Object.keys(this.createLabRequestForm.controls).forEach((key) => {
      this.createLabRequestForm.controls[key].markAsDirty();
    });
  }
  ngSelectDropdownChangeEvent(value: any) {
    if (value.length > 0) {
      this.isSaveButtonDisabled = false;
    }
    else {
      this.isSaveButtonDisabled = true;
    }
  }
}
